<ng-container *ngIf="select$ | async"></ng-container>

<div class="dialog-content-wrapper" fusePerfectScrollbar>
  <mat-toolbar class="mat-accent m-0">
    <mat-toolbar-row class="flex flex-row justify-between items-center flex-1">
      <span class="title dialog-title" i18n>Облицовка элемента</span>

      <button mat-button class="mat-icon-button" (click)="dialogRef.close(undefined)" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-0 pb-0 m-0" fusePerfectScrollbar>
    <ng-container *ngIf="matched$ | async as data">
      <table *ngIf="!data.error" mat-table #table [dataSource]="dataSource" class="w-full">
        <mat-text-column
          i18n-headerText
          headerText="Оригинальная облицовка"
          name="originalMaterial"
          [dataAccessor]="getOldEdgeName"></mat-text-column>

        <mat-text-column
          i18n-headerText
          headerText="Новая облицовка"
          name="newMaterial"
          [dataAccessor]="getNewEdgeName"></mat-text-column>

        <ng-container matColumnDef="change">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let item">
            <button
              mat-icon-button
              i18n-matTooltip
              matTooltip="Выбрать облицовку из базы материалов"
              *ngIf="
                getMatchedEdgesByThickness(item.originalThickness).length === 0 &&
                cuttingOptions?.cuttingProductSettings?.addMaterialsFromMatBase
              "
              (click)="openMaterialBaseDialog(item)">
              <mat-icon>layers</mat-icon>
            </button>

            <button
              mat-icon-button
              [disabled]="getMatchedEdgesByThickness(item.originalThickness).length === 0"
              *ngIf="getMatchedEdgesByThickness(item.originalThickness).length > 0"
              [matTooltipDisabled]="getMatchedEdgesByThickness(item.originalThickness).length !== 0"
              i18n-matTooltip
              matTooltip="Для данного материала элемента облицовка не найдена"
              (click)="openMatchedEdgesDialog(item)">
              <mat-icon>edit</mat-icon>
            </button>

            <button
              mat-icon-button
              disabled
              *ngIf="
                getMatchedEdgesByThickness(item.originalThickness).length === 0 &&
                !cuttingOptions?.cuttingProductSettings?.addMaterialsFromMatBase
              "
              i18n-matTooltip
              matTooltip="Для данного материала элемента облицовка не найдена">
              <mat-icon>edit</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>
      </table>

      <div *ngIf="!data.error && !data.result">Loading…</div>

      <div *ngIf="data.error">
        <csl-no-data-display></csl-no-data-display>
      </div>
    </ng-container>
  </div>

  <mat-divider> </mat-divider>

  <div mat-dialog-actions class="m-0 p-4 flex flex-row justify-end items-center">
    <button mat-raised-button class="mat-accent" (click)="dialogRef.close(edges)" i18n>ОК</button>
    <button mat-button (click)="dialogRef.close(undefined)" i18n>ОТМЕНА</button>
  </div>
</div>
